var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("ssrManage.announce"),
        visible: _vm.isShow,
        width: "45%",
      },
      on: {
        close: function ($event) {
          return _vm.cancel("showIssueDialog")
        },
      },
    },
    [
      _c(
        "div",
        [
          _c(
            "el-form",
            { ref: "form", attrs: { model: _vm.formData } },
            [
              _c("div", [
                _vm._v(
                  _vm._s(_vm.$t("ssrManage.round")) +
                    "：Round " +
                    _vm._s(_vm._f("romanNum")(_vm.roundNumber))
                ),
              ]),
              _c(
                "div",
                [
                  _vm._v(_vm._s(_vm.$t("ssrManage.roundEndDate")) + "： "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "roundEndDate",
                        rules: { required: true, message: "请输入" },
                      },
                    },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          "picker-options": {
                            disabledDate: (val) =>
                              val < new Date(new Date() - 1000 * 60 * 60 * 24),
                          },
                          type: "date",
                        },
                        model: {
                          value: _vm.formData.roundEndDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "roundEndDate", $$v)
                          },
                          expression: "formData.roundEndDate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("div", { staticStyle: { "margin-top": "15px" } }, [
                _vm._v("BCC"),
              ]),
              _c(
                "el-table",
                {
                  ref: "bccList",
                  attrs: {
                    data: _vm.formData.bccList,
                    border: "",
                    "highlight-current-row": "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "supplierName",
                      label: _vm.$t("ssrManage.supplierName"),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: `bccList[${scope.$index}].name`,
                                  rules: { required: true, message: "请输入" },
                                },
                              },
                              [
                                _c("el-input", {
                                  model: {
                                    value: scope.row.name,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "name", $$v)
                                    },
                                    expression: "scope.row.name",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "email", label: "Email" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: `bccList[${scope.$index}].email`,
                                  rules: {
                                    type: "email",
                                    required: true,
                                    message: "请输入邮箱地址",
                                  },
                                },
                              },
                              [
                                _c("el-input", {
                                  model: {
                                    value: scope.row.email,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "email", $$v)
                                    },
                                    expression: "scope.row.email",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { width: "100" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return scope.row.canDel
                              ? [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.formData.bccList.splice(
                                            scope.$index,
                                            1
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("delete")]
                                  ),
                                ]
                              : undefined
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                ],
                1
              ),
              _c(
                "el-link",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.addEmail("BCC")
                    },
                  },
                },
                [_vm._v("Add")]
              ),
              _c("div", { staticStyle: { "margin-top": "15px" } }, [
                _vm._v("TO"),
              ]),
              _c(
                "el-table",
                {
                  ref: "toList",
                  attrs: {
                    data: _vm.formData.toList,
                    border: "",
                    "highlight-current-row": "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "supplierName", label: "Name" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: `toList[${scope.$index}].name`,
                                  rules: { required: true, message: "请输入" },
                                },
                              },
                              [
                                _c("el-input", {
                                  model: {
                                    value: scope.row.name,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "name", $$v)
                                    },
                                    expression: "scope.row.name",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "email", label: "Email" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: `toList[${scope.$index}].email`,
                                  rules: {
                                    type: "email",
                                    required: true,
                                    message: "请输入邮箱地址",
                                  },
                                },
                              },
                              [
                                _c("el-input", {
                                  model: {
                                    value: scope.row.email,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "email", $$v)
                                    },
                                    expression: "scope.row.email",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.formData.toList.splice(
                                      scope.$index,
                                      1
                                    )
                                  },
                                },
                              },
                              [_vm._v("delete")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "el-link",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.addEmail("TO")
                    },
                  },
                },
                [_vm._v("Add")]
              ),
              _c("div", { staticStyle: { "margin-top": "15px" } }, [
                _vm._v("CC"),
              ]),
              _c(
                "el-table",
                {
                  ref: "ccList",
                  attrs: {
                    data: _vm.formData.ccList,
                    border: "",
                    "highlight-current-row": "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "supplierName",
                      label: "Name",
                      "column-key": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: `ccList[${scope.$index}].name`,
                                  rules: { required: true, message: "请输入" },
                                },
                              },
                              [
                                _c("el-input", {
                                  model: {
                                    value: scope.row.name,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "name", $$v)
                                    },
                                    expression: "scope.row.name",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "email", label: "Email" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: `ccList[${scope.$index}].email`,
                                  rules: {
                                    type: "email",
                                    required: true,
                                    message: "请输入邮箱地址",
                                  },
                                },
                              },
                              [
                                _c("el-input", {
                                  model: {
                                    value: scope.row.email,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "email", $$v)
                                    },
                                    expression: "scope.row.email",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.formData.ccList.splice(
                                      scope.$index,
                                      1
                                    )
                                  },
                                },
                              },
                              [_vm._v("delete")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "el-link",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.addEmail("CC")
                    },
                  },
                },
                [_vm._v("Add")]
              ),
              _c(
                "div",
                {
                  staticClass: "foot-btn",
                  staticStyle: {
                    "padding-top": "10px",
                    "text-align": "center",
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.confirmMethod },
                    },
                    [_vm._v(_vm._s(_vm.$t("ssrManage.announce")))]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.cancel("showIssueDialog")
                        },
                      },
                    },
                    [_vm._v(_vm._s("Cancel"))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }